export class Gallery {
    public img: any
    public alt: any
    public main: boolean;
    constructor() {
        this.img = null;
        this.alt = {};
        this.main = false;
    }
}

export class Product {
    public id: number;
    public name: {es: string};
    public brand: {es: string};
    public ref: string;
    public description: {es: string};
    public category_id: number;
    public producer_id: number;
    public producer_type: string;
    public producer: any;
    public attributes: any[];
    public published: boolean;
    public gallery: Gallery[];
    public created_at: string;
    public updated_at: string;
    public deleted_at: string;

    constructor() {
        this.id = 0;
        this.name = {es: ''};
        this.brand = {es: ''};
        this.ref = '';
        this.description = {es: ''};
        this.category_id = 0;
        this.producer_id = 0;
        this.producer_type = '';
        this.producer = {};
        this.attributes = [];
        this.published = true;
        this.gallery = [];
        this.created_at = '';
        this.updated_at = '';
        this.deleted_at = '';
    }
}
